import React, { useState } from 'react';
import { Form, Input, Button, Card, notification, Typography } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { resetForgottenPassword } from '../../api/authApi';
import { PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE } from '../../utils/validationConstants';
import './ForgotPassword.css';

const { Text } = Typography;

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const { push } = useHistory();
  const location = useLocation();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const searchParams = new URLSearchParams(location?.search);
      const token = searchParams?.get('verify');
      if (!token) {
        notification.error({
          placement: 'bottomRight',
          message: 'Invalid Token',
          description: 'The reset token is invalid or has expired.',
        });
        return;
      }
      await resetForgottenPassword(token, values.password);
      notification.success({
        placement: 'bottomRight',
        message: 'Password Successfully Reset',
        description: 'Your password has been updated successfully. You can now login with your new password.',
      });
      push('/auth/login');
    } catch (err) {
      notification.error({
        placement: 'bottomRight',
        message: 'Error',
        description: err?.response?.data?.msg || 'Failed to reset password.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-content">
        <Card
          style={{
            width: 500,
            padding: '50px 20px 20px',
            backgroundColor: '#fff',
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <h1 style={{ fontSize: '24px', marginBottom: '8px', color: '#1890ff' }}>Reset Password</h1>
            <Text style={{ color: '#666', fontSize: '14px' }}>
              Enter your new password below to reset your account password.
            </Text>
          </div>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="password"
              label="New Password"
              rules={[
                {
                  required: true,
                  message: 'Please enter your new password',
                },
                {
                  min: 24,
                  message: 'Password must be at least 24 characters long',
                },
                {
                  pattern: PASSWORD_REGEX,
                  message: PASSWORD_VALIDATION_MESSAGE,
                },
              ]}
            >
              <Input.Password placeholder="Enter your new password" />
            </Form.Item>
            <Button
              htmlType="submit"
              block
              type="primary"
              loading={loading}
              style={{ backgroundColor: '#1890ff', border: 'none' }}
            >
              Reset Password
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default ResetPassword;
